// Central content store for PT. Bumi Cakrawala Logistik company profile site.
// Keeping all copy here mirrors the seoRoutes.js pattern used across Albert's other projects.

export const company = {
  legalName: "PT. Bumi Cakrawala Logistik",
  brand: "Bumi Logistics",
  tagline: "Strategic Freight & Supply Chain Partner",
  slogan: "Connecting Business Across Nations",
  domain: "https://www.bumilogistics.id",
  phone: "+6221-8064-1900",
  mobile: "+62 819-3328-1204",
  emails: {
    partnership: "ff@bumilogistics.id",
    customerService: "cs@bumilogistics.id",
  },
  addressCountry: "ID",
};

export const overview = {
  paragraphs: [
    "PT. Bumi Cakrawala Logistik is a trusted logistics and supply chain solutions provider dedicated to delivering seamless, efficient, and reliable logistics services across domestic and international markets.",
    "With a strong commitment to operational excellence, customer satisfaction, and global connectivity, we provide integrated logistics solutions that help businesses move goods, projects, and opportunities across borders with confidence.",
    "As a strategic freight and supply chain partner, we combine industry expertise, extensive global networks, and innovative logistics solutions to support the evolving needs of our clients in various industries worldwide.",
  ],
};

export const vision =
  "To become a leading global logistics partner, connecting businesses worldwide through innovative, reliable, and integrated supply chain solutions.";

export const missions = [
  "Deliver world-class logistics services with professionalism and integrity.",
  "Create value for customers through efficient and cost-effective supply chain solutions.",
  "Build long-term partnerships based on trust, transparency, and performance.",
  "Continuously innovate and adapt to the changing dynamics of global trade.",
  "Support sustainable business growth through reliable logistics infrastructure and expertise.",
];

export const services = [
  {
    code: "FWD",
    icon: "plane",
    image: "/images/services/freight-forwarding.jpg",
    title: "International Freight Forwarding",
    description:
      "Comprehensive air, sea, and multimodal freight solutions connecting businesses to global markets with efficiency, visibility, and reliability.",
  },
  {
    code: "CUS",
    icon: "check",
    image: "/images/services/customs-clearance.jpg",
    title: "Customs Clearance",
    description:
      "Professional customs brokerage and compliance services ensuring smooth import and export processes while meeting all regulatory requirements.",
  },
  {
    code: "WHD",
    icon: "warehouse",
    image: "/images/services/warehousing.jpg",
    title: "Warehousing & Distribution",
    description:
      "Strategically managed warehousing facilities and inventory solutions designed to optimize storage, fulfillment, and distribution operations.",
  },
  {
    code: "INL",
    icon: "truck",
    image: "/images/services/inland-transportation.jpg",
    title: "Inland Transportation",
    description:
      "Reliable domestic transportation services supported by a trusted network and experienced operations team to ensure timely delivery.",
  },
  {
    code: "PRJ",
    icon: "box",
    image: "/images/services/project-logistics.jpg",
    title: "Project Logistics & Special Cargo",
    description:
      "End-to-end management of oversized, heavy-lift, industrial, and complex project cargo requiring specialized handling and transportation expertise.",
  },
  {
    code: "EVT",
    icon: "calendar",
    image: "/images/services/event-logistics.jpg",
    title: "Event & Exhibition Logistics",
    description:
      "Comprehensive logistics support for international exhibitions, trade shows, concerts, sporting events, and corporate events, including temporary importation, customs handling, transportation, and onsite coordination.",
  },
  {
    code: "SCM",
    icon: "chain",
    image: "/images/services/supply-chain-solutions.jpg",
    title: "Supply Chain Solutions",
    description:
      "Integrated supply chain management services designed to improve operational efficiency, reduce costs, and enhance business performance.",
  },
];

export const whyChooseUs = [
  {
    number: "01",
    title: "Industry Expertise",
    description:
      "Experienced professionals with extensive knowledge of freight forwarding, customs regulations, project logistics, and event logistics.",
  },
  {
    number: "02",
    title: "Global Network",
    description:
      "Strong partnerships with international agents, carriers, and logistics partners worldwide.",
  },
  {
    number: "03",
    title: "End-to-End Solutions",
    description:
      "A single logistics partner capable of managing every stage of the supply chain.",
  },
  {
    number: "04",
    title: "Reliability & Compliance",
    description:
      "Commitment to operational excellence, safety, regulatory compliance, and service quality.",
  },
  {
    number: "05",
    title: "Customer-Centric Approach",
    description:
      "Tailored logistics solutions designed to meet specific customer requirements and business objectives.",
  },
];

export const industries = [
  { icon: "factory", title: "Manufacturing" },
  { icon: "bolt", title: "Energy & Mining" },
  { icon: "oil", title: "Oil & Gas" },
  { icon: "construction", title: "Construction & Infrastructure" },
  { icon: "car", title: "Automotive" },
  { icon: "cart", title: "Retail & Consumer Goods" },
  { icon: "phone", title: "Technology & Electronics" },
  { icon: "calendar2", title: "Event & Exhibition Organizers" },
  { icon: "bank", title: "Government & Public Sector" },
  { icon: "ball", title: "Sports & Entertainment" },
];

export const leadership = {
  ceo: {
    name: "Faiz Fajri",
    role: "Chief Executive Officer",
    photo: "/images/team/faiz-fajri.jpg",
    bio: [
      "Faiz Fajri is the CEO of PT. Bumi Cakrawala Logistik. With extensive experience in international freight forwarding, customs clearance, project logistics, and supply chain management, he has successfully built the company into a trusted logistics partner serving businesses across various industries.",
      "Under his leadership, PT. Bumi Cakrawala Logistik continues to expand its global reach, strengthen strategic partnerships, and deliver innovative logistics solutions that connect businesses across nations.",
    ],
  },
  team: [
    {
      name: "Caya Hanum",
      role: "Director of Finance/OPS",
      photo: "/images/team/caya-hanum.jpg",
      bio: "Caya Hanum serves as the Director of Finance and Operations at PT. Bumi Cakrawala Logistik. With a strong focus on financial strategy and operational efficiency, she plays a crucial role in ensuring that the company\u2019s day-to-day logistics operations run seamlessly. Her leadership in managing resources and optimizing operational workflows ensures that the company consistently delivers cost-effective and highly reliable supply chain solutions to clients worldwide.",
    },
    {
      name: "Virgianisa Tiara",
      role: "Head of Customer Service",
      photo: "/images/team/virgianisa-tiara.jpg",
      bio: "Ara, as the Head of Customer Service at PT. Bumi Cakrawala Logistik, plays a vital role in delivering our customer-centric approach. She leads the support team to ensure seamless communication, transparent updates, and rapid resolutions for all client inquiries. With a strong commitment to customer satisfaction, Ara ensures that every tailored logistics solution is executed with the highest standard of service, giving our clients complete confidence in their supply chain.",
    },
  ],
};

export const commitment =
  "At PT. Bumi Cakrawala Logistik, we believe logistics is more than moving cargo — it is about connecting businesses, creating opportunities, and enabling growth. We are committed to delivering excellence in every shipment, every project, and every partnership.";
